export default __webpack_public_path__ + "static/media/image5.e9ad6129.jpg";